import { useCallback } from 'react';

import { useLanguage } from '../../contexts/language';

import { PageTitle } from '../page-title';
import { RecordRows } from '../record-rows';
import { StepActions } from '../step-actions';

import styles from './style.module.css';

// Step 6: every answer for the day, each a link back to the step that asks
// it, and Save record. The steps have already saved their answers, so saving
// here closes the record and returns to the Diary on this day; there is
// nothing left to send, and nothing is filled in for the questions skipped.
export function CheckStep({ record, onBack, onSaved }) {
  const { text } = useLanguage();

  const onSubmit = useCallback(function(event) {
    event.preventDefault();
    onSaved();
  }, [ onSaved ]);

  return (
    <form className={ styles.form } onSubmit={ onSubmit } noValidate>
      <PageTitle title={ text.checkTitle } intro={ text.checkHint }/>

      <div className={ styles.summary }>
        <RecordRows day={ record } editable/>
      </div>

      <StepActions onBack={ onBack } submitLabel={ text.saveRecord }/>
    </form>
  );
}
